/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/ContentActionsAPI'
], (APIFactory, ContentActionsAPI) => {

	class ContentActions {

		constructor() {
			this.api = APIFactory.createAPI(this, [ContentActionsAPI]);
			this.providers = {};
		}

		registerProvider(name, provider) {
			this.providers[name] = provider;
		}

		getContentActionList(idList) {
			const contentActionList = [];
			Object.values(this.providers).forEach(provider => {
				if (provider.getContentActionList && typeof(provider.getContentActionList) === 'function'){
					let actions = null;
					try {
						actions = provider.getContentActionList(idList);
					} catch(e) {
						console.log(e);
					}
					if(actions) {
						contentActionList.push(...actions);
					}
				}
			});
			return contentActionList;
		}

		getAPI(){
			return this.api;
		}
	}

	return ContentActions;
});
